import { buttonBase, controleModalOverlayStyle, controleModalStyle, modalCloseButtonStyle } from "../../shared/styles/layoutStyles";
import ModalBackdrop from "../../../../components/ModalBackdrop";

export function renderValidatePreProductionConfirmModal(view) {
    const { setShowValidatePreProductionConfirm, showValidatePreProductionConfirm, validatePreProduction, workspace } = view;
    if (!showValidatePreProductionConfirm) return null;
    return (
        <div style={controleModalOverlayStyle}>
            <ModalBackdrop onClose={() => setShowValidatePreProductionConfirm(false)} />
            <div role="alertdialog" aria-modal="true" aria-labelledby="validate-preprod-title" style={{ ...controleModalStyle, position: "relative", zIndex: 1 }}>
                <div style={{ display: "flex", justifyContent: "space-between", gap: "12px", alignItems: "flex-start" }}>
                    <div>
                        <h2 id="validate-preprod-title" style={{ margin: 0, color: "#0f172a", fontSize: "18px", fontWeight: 950 }}>Figer la pré-production ?</h2>
                        <p style={{ margin: "8px 0 0", color: "#475569", fontSize: "13px", lineHeight: 1.5 }}>
                            La partie pré-production sera enregistrée dans son état actuel, puis les champs et pièces jointes de cette partie ne seront plus modifiables.
                        </p>
                    </div>
                    <button type="button" onClick={() => setShowValidatePreProductionConfirm(false)} style={modalCloseButtonStyle}>×</button>
                </div>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", flexWrap: "wrap" }}>
                    <button type="button" onClick={() => setShowValidatePreProductionConfirm(false)} style={{ ...buttonBase, background: "white", color: "#334155" }}>
                        Annuler
                    </button>
                    <button type="button" onClick={validatePreProduction} disabled={workspace.saving} style={{ ...buttonBase, background: "#16a34a", borderColor: "#15803d", color: "white", fontWeight: 900 }}>
                        Confirmer
                    </button>
                </div>
            </div>
        </div>
    );
}
